import { ResponsiveTable } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import EntrySkeletons from '../ChangeEntry/EntrySkeleton'

type WrapperProps = {
  children: ReactNode
}

// Lives here (a leaf module) rather than in ChangeLogGeneralView so the eagerly-loaded
// ChangeLogPageSkeleton doesn't pull the whole change-log view graph into the entry chunk
export const ResponsiveTableWrapper = ({ children }: WrapperProps): JSX.Element => {
  const [t] = useTranslation()
  return (
    <ResponsiveTable
      stickyHeader={false}
      totalColumnCount={3}
      atSizeColumns={{
        lg: {
          labels: [t('change-log.change.header'), t('change-log.value.header'), t('change-log.date.header')],
          columnWidths: [3, 5, 4],
        },
        default: { labels: [t('change-log.change.header')] },
      }}
    >
      {children}
    </ResponsiveTable>
  )
}

/**
 * Loading placeholder matching the change log table layout, for use while the changes are unavailable.
 */
export default function ChangeLogGeneralViewSkeleton(): JSX.Element {
  return (
    <ResponsiveTableWrapper>
      <EntrySkeletons count={14} />
    </ResponsiveTableWrapper>
  )
}
